import { ExposureMetric, ExposureValue } from '@/types/AccountExposure';
import { IsNullOrUndefinedOrNaN } from '@/utilities/Helpers';
import { AccountAttribute } from '@/types/Account';
import { User } from '@/types/User';
import { UserHasPermission } from '@/utilities/AuthUtils';
import { UserPermission } from '@/types/UserPermissions';

export interface Column<T = unknown> {
  fieldName: keyof T
  title: string
  classes?: string
  type: string
  filter?: string
  useFilteredExport?: boolean;
  url?: (data: T) => string;
  exposureCategory?: string;
  exposureMetricId?: number;
  accessoryIcon?: string;
  annualized?: boolean;
  showInfoIcon?: keyof T; // property to determine whether to show info icon or not
  showInfoFieldName?: keyof T; // tool tip text for the show info icon
}

export interface Chart<T = unknown> {
  title: string
  fieldName: keyof T
  isPercentage?: boolean
}

export interface BenchmarkContext {
  injectedExposureData: ExposureValue[]
  injectedExposureTypes: ExposureMetric[]
  injectedExposureCategories: Record<string, number>
}

export const SHOW_ALL = 'showAll';
export const PUBLIC = 'public';

export function calc<T>(data: T[], prop: keyof T, calculation: (v: number[]) => number, includeZero = false): number {
  const arr = [...data].filter(d => d[prop]).map(d => Number(d[prop])).filter(x => includeZero ? !IsNullOrUndefinedOrNaN(x) : !!x);
  const value = calculation(arr);
  return Math.round(value * 100) / 100;
}

export interface AttributeOption {
  label: string
  value: string
}

export const sameOwnershipType = (t: AccountAttribute, ownershipType: string): boolean =>
  t.ownershipType.toLowerCase().trim() === ownershipType.toLowerCase().trim();

export const both = (t: AccountAttribute): boolean => t.ownershipType.toLowerCase().trim() === 'both';

export interface BenchmarkOption {
  name: string
  link: string
  requirements: ((user: User | undefined) => boolean)[]
}

export const benchmarkOptions: BenchmarkOption[] = [
  { name: 'D&O', link: 'dno', requirements: [] },
  { name: 'Cyber', link: 'cyber', requirements: [(user: User | undefined): boolean => UserHasPermission(user, UserPermission.Cyber)] },
  { name: 'Fiduciary', link: 'fiduciary', requirements: [] },
  { name: 'Umbrella', link: 'umbrella', requirements: [] },
  { name: 'EPL', link: 'epl', requirements: [] },
  { name: 'Crime', link: 'crime', requirements: [] }
];
